import { render, staticRenderFns } from "./CompanyInformationFormLocked.vue?vue&type=template&id=308b4d62&scoped=true&"
import script from "./CompanyInformationFormLocked.vue?vue&type=script&lang=js&"
export * from "./CompanyInformationFormLocked.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInformationFormLocked.vue?vue&type=style&index=0&id=308b4d62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308b4d62",
  null
  
)

export default component.exports